function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.date.to-json.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
var StoreFilters = /*#__PURE__*/function () {
  function StoreFilters(config) {
    _classCallCheck(this, StoreFilters);
    try {
      if (config.event === undefined || config.event === null) throw new Error('CLass StoreFilters need event in parameters');
      this.event = config.event;
    } catch (err) {
      // eslint-disable-next-line no-console
      console.log('Error class StoreFilters', err);
    }
  }

  /**
   * format all values of filters for dispatching
   * @param values
   * @returns {{}}
   */
  return _createClass(StoreFilters, [{
    key: "format",
    value: function format(values) {
      var _data = {};
      var _responseObj = {};
      var _haveValues = Object.keys(values).length > 0;
      if (_haveValues) {
        for (var _value in values) {
          if (Array.isArray(values[_value])) {
            _data["".concat(_value)] = "".concat(values[_value].join('#|'));
          } else {
            _data["".concat(_value)] = "".concat(values[_value]);
          }
        }

        //replace caracter "," with "#" and delete all "{}"
        _responseObj['applieds'] = JSON.stringify(_data);
      }
      return _responseObj;
    }

    /**
     * dispatch data in store
     * @param details example {
     * action : 'filter' || 'sort' || 'paginate',
     * params : {param1 : value, params2 : value2 ..}
     * filters : object of selected filters
     * }
     */
  }, {
    key: "dispatch",
    value: function dispatch() {
      var details = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      try {
        if (details.action === undefined || details.action === null) throw new Error('Method dispatch need action in parameters');
        var data = {};
        data[this.event.dataKey] = details.filters;
        var detailsEvent = _objectSpread(_objectSpread({
          action: details.action
        }, details.params), data);
        this.event.target(detailsEvent);
      } catch (err) {
        // eslint-disable-next-line no-console
        console.log('Error Method Dispatch', err);
      }
    }
  }]);
}();
export default StoreFilters;